import { useAccountBadgeActionChecks, } from '../../../../ui/features/badge-management/hooks/useAccountBadgeActionChecks';
import { useAccountBadgeReissueBulkAction } from '../../../../ui/features/badge-management/hooks/useAccountBadgeReissueBulkAction';
import { useAddAccountBadgeAction } from '../../../../ui/features/badge-management/hooks/useAddAccountBadgeAction';
/**
 * Centralized place for all multi Account Badge bulk-actions
 */
export function useAccountBadgeBulkActions({ badgeId, accountBadgesAll, accountBadgeRows, accountBadgeSelectedIds, onActionCompleted, }) {
    const accountBadgesSelected = accountBadgeRows.filter((row) => accountBadgeSelectedIds.includes(row.id));
    const checks = useAccountBadgeActionChecks({ accountBadgesSelected });
    const { handleAddAccount } = useAddAccountBadgeAction({
        badgeId,
        accountBadgesAll,
        accountBadgeRows,
        accountBadgeSelectedIds,
        onActionCompleted,
    });
    const { handleReissueAccountBadges } = useAccountBadgeReissueBulkAction();
    return Object.assign(Object.assign({}, checks), { canAddAccount: true, handleAddAccount, handleReissueAccountBadges: () => {
            handleReissueAccountBadges(badgeId, accountBadgeSelectedIds.map((id) => ({ id })), onActionCompleted);
        } });
}
